import { combineReducers } from 'redux'
import statusReducer from './caseworker/statusReducer'
import reportsReducer from './caseworker/reportsReducer'
import identityReducer from './caseworker/identityReducer'
import teamReducer from './caseworker/teamReducer'
import clientOrgsReducer from './caseworker/clientOrgsReducer'

export type { CaseworkerStatusState } from './caseworker/statusReducer'
export type { CaseworkerReportsState } from './caseworker/reportsReducer'
export type { CaseworkerIdentityState } from './caseworker/identityReducer'
export type { CaseworkerTeamState } from './caseworker/teamReducer'
export type { CaseworkerClientOrgsState } from './caseworker/clientOrgsReducer'

const reducer = combineReducers({
    status: statusReducer,
    reports: reportsReducer,
    identity: identityReducer,
    team: teamReducer,
    clientOrgs: clientOrgsReducer,
})

export default reducer
